module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/0128261846f16bb8cfb540f89ad942e9.svg";